const translationPath = '$vuetify.pages.Logging.messages';

const assocc = {
    options: 'optionName'
};

const roles = ['intern', 'operator', 'accountant', 'manager', 'corporate-admin', 'corporate-user', 'boss', 'admin', 'sales-manager'];

export function translateActionType(actionItem) {
    const types = {
        'setting-change': settingsUpdate,
        'user-login': userLogin,
        'setting-set-default': settingsUpdate,
        'report-change-access': reportChangeAccess,
        'change-action-type-status': changeActionTypeStatus,
        'resale-create': createResale,
        'resale-edit': editResale,
        'resale-delete': deleteResale,
        'report-view': reportView,
        'setting-edit': edit.bind(this, 'Settings'),
        'client-create': create.bind(this, 'Client'),
        'client-edit': edit.bind(this, 'Client'),
        'driver-create': create.bind(this, 'Driver'),
        'driver-edit': edit.bind(this, 'Driver'),
        'driver-delete': remove.bind(this, 'Driver'),
        'operator-create': create.bind(this, 'Operator'),
        'operator-edit': edit.bind(this, 'Operator'),
        'operator-delete': deleteOperator,
        'client-bonus-create': create.bind(this, 'ClientBonus'),
        'client-bonus-edit': edit.bind(this, 'ClientBonus'),
        'tariff-create': create.bind(this, 'Tariff'),
        'tariff-edit': edit.bind(this, 'Tariff'),
        'tariff-delete': financeRemove.bind(this, 'Tariff'),
        'commission-create': create.bind(this, 'Commission'),
        'commission-edit': edit.bind(this, 'Commission'),
        'commission-delete': remove.bind(this, 'Commission'),
        'commission-border-create': create.bind(this, 'CommissionBorder'),
        'commission-border-edit': edit.bind(this, 'CommissionBorder'),
        'commission-border-delete': remove.bind(this, 'CommissionBorder'),
        'penalty-create': create.bind(this, 'Penalty'),
        'penalty-edit': edit.bind(this, 'Penalty'),
        'penalty-delete': financeRemove.bind(this, 'Penalty'),
        'driver-bonus-create': create.bind(this, 'DriverBonus'),
        'driver-bonus-edit': edit.bind(this, 'DriverBonus'),
        'change-driver-status': changeDriverStatus,
        'client-bonus-delete': remove.bind(this, 'ClientBonus'),
        'driver-bonus-delete': remove.bind(this, 'DriverBonus'),
        'send-driver-password': sendDriverPassword,
        'operator-back-to-work': backToWork,
        'report-edit': edit.bind(this, 'Report'),
        'report-create': create.bind(this, 'Report'),
        'add-driver-payment': addDriverPayment,
        'reset-imei': resetImei,
        'karma-change': karmaChange,
        'option-level-edit': optionLevelEdit,
        "settings-1km-duration": minutesPerKilometer,
        "section-create": temporaryActionTranslator,
        "section-edit": temporaryActionTranslator,
        "section-delete": temporaryActionTranslator,
        "product-create": temporaryActionTranslator,
        "product-edit": temporaryActionTranslator,
        "product-delete": temporaryActionTranslator,
        "product-restore": temporaryActionTranslator,
        "establishment-type-create": temporaryActionTranslator,
        "establishment-type-edit": temporaryActionTranslator,
        "establishment-type-delete": temporaryActionTranslator,
        "establishment-category-create": temporaryActionTranslator,
        "establishment-category-edit": temporaryActionTranslator,
        "establishment-category-delete": temporaryActionTranslator,
        "establishment-create": temporaryActionTranslator,
        "establishment-edit": temporaryActionTranslator,
        "establishment-delete": temporaryActionTranslator,
        "establishment-restore": temporaryActionTranslator,
    };

    return types[actionItem.actionType.name] && types[actionItem.actionType.name].call(this, actionItem);
}

function temporaryActionTranslator(actionItem) {
    const { actionType: { name: type }, action }  = actionItem;

    return this.$vuetify.lang.t(`${translationPath}.${type}`, Object.entries(action).map(i => i.join(': ')).join('\n'));
}

function minutesPerKilometer(actionItem) {
    const { actionType: { name: type }, action }  = actionItem;

    return this.$vuetify.lang.t(`${translationPath}.${type}`, action.minutesPerKilometer);
}

function createResale(actionItem) {
    const { actionType: { name: type }, action }  = actionItem;
    const { dealerId, buyerId } = action;
    const className = action.optionClass && action.optionClass.className || 'All';
    const brandsNames = [dealerId, buyerId].map(id => this.$options.filters.brand(id));
    const parameters = Object.reject(action, ['dealerId', 'buyerId', 'optionClass', 'optionClassId']);

    const changes = Object.keys(parameters).map(key => {
        const translatedLabel = this.$vuetify.lang.t(`$vuetify.models.Resale.${key}`);
        return `\n${translatedLabel}: ${parameters[key]}`;
    }).join();

    return this.$vuetify.lang.t(`${translationPath}.${type}`, ...brandsNames, className || 'All', changes);
}

function editResale(actionItem) {
    const { actionType: { name: type }, action }  = actionItem;
    const { dealerId, buyerId, oldData, newData } = action;
    const className  = action.optionClass && action.optionClass.className || 'All';

    const brandsNames = [dealerId, buyerId].map(id => this.$options.filters.brand(id));

    const changes = Object.keys(oldData).map(key => {
        const translatedKey = this.$vuetify.lang.t(`$vuetify.models.Resale.${key}`);
        const translation = this.$vuetify.lang.t(`${
            translationPath}.change`, translatedKey,
            oldData[key],
            newData[key]
        );
        return `\n${translation}`;
    }).join();

    return this.$vuetify.lang.t(`${translationPath}.${type}`, ...brandsNames, className, changes);
}

function deleteResale(actionItem) {
    const { actionType: { name: type }, action }  = actionItem;
    const { dealerId, buyerId } = action;

    const className = action.optionClass && action.optionClass.className || 'All';
    const brandsNames = [dealerId, buyerId].map(id => this.$options.filters.brand(id));

    return this.$vuetify.lang.t(`${translationPath}.${type}`, ...brandsNames, className);
}

function deleteOperator(actionItem) {
    const { actionType: { name: type }, action }  = actionItem;
    const { firstName, lastName, loginName, roleName } = action;

    const roleTranslation = this.$vuetify.lang.t(`$vuetify.roles.${roleName}`).toLowerCase();

    // removed operator full name
    const operatorFullName = `${firstName} ${lastName}`;

    return this.$vuetify.lang.t(`${translationPath}.${type}`, operatorFullName, loginName, roleTranslation);
}

function changeActionTypeStatus(actionItem) {
    const { actionType: { name: type }, action: { changed } }  = actionItem;
    return (changed || []).map(it => {
        const { name, enabled } = it;

        const nameText = this.$vuetify.lang.t(`$vuetify.actionTypes.${name}`);
        const enabledText = isEnabled.call(this, enabled);
        return this.$vuetify.lang.t(`${translationPath}.${type}`, nameText, enabledText);
    }).join('\n');
}

function settingsUpdate(actionItem) {
    const { brand, configType } = actionItem.action;
    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, configType, brand);
}

function reportChangeAccess(actionItem) {
    const { added, removed, firstName, lastName } = actionItem.action;
    const translate = [this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, firstName, lastName)];

    if (added.length) {
        translate.push(this.$vuetify.lang.t(`${translationPath}.addAccess`, translateReports.call(this, added)));
    }

    if (removed.length) {
        translate.push(this.$vuetify.lang.t(`${translationPath}.removeAccess`, translateReports.call(this, removed)));
    }

    return translate.join('\n');
}

function translateReports(reports) {
    const formattedReports = reports.map(it => {
        return ` ${this.$vuetify.lang.t(`${translationPath}.nameReport`)} ${it.name},
        ${this.$vuetify.lang.t(`${translationPath}.categoryReport`)} ${it.category}`;
    });

    return `[ ${formattedReports} ]`;
}

function reportView(actionItem) {
    const { action: { name, category }} = actionItem;

    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, category, name);
}

function create(model, actionItem) {
    const copiedActionItem = { ...actionItem };
    const translatedModel = this.$vuetify.lang.t(`$vuetify.pages.Logging.models.${model}`);

    const changes = Object.entries(copiedActionItem.action).filter(it => !!it[1]).map((it) => {
        let [label, value] = it;
        const translatedLabel = this.$vuetify.lang.t(`$vuetify.models.${model}.${ label }`);

        if (copiedActionItem.action.perDayType) {
            copiedActionItem.action.perDayType = this.$vuetify.lang.t(`$vuetify.pages.Commissions.perDayTypeOptions.since-first-login`);
        }

        if (typeof value === 'boolean') {
            value = isEnabled.call(this, value);
        }

        if (roles.includes(value)) {
            value = roleName.call(this, value);
        }

        if (Array.isArray(value)) {
            return `\n${translatedLabel}: ${ formatArray(value, label) }`;
        }

        return `\n${translatedLabel}: ${value}`;
    });

    return this.$vuetify.lang.t(`${translationPath}.create`, translatedModel, changes);
}

function edit(model, actionItem) {
    const { action: { oldData, newData, key }} = actionItem;
    let { action: { title } } = actionItem;
    const translate = (params, key) => this.$vuetify.lang.t(`${translationPath}.${key}`, ...params);
    const translatedModel = this.$vuetify.lang.t(`$vuetify.pages.Logging.models.${model}`);
    const copiedNewData = { ... newData };

    if (actionItem.actionType.name === 'setting-edit') {
        title = getSettingsEditTitle.call(this, title, key);
    }

    let changes = Object.entries(oldData).map((it, index) => {
        let [label, value] = it;
        const fieldTranslation = this.$vuetify.lang.t(`$vuetify.models.${model}.${label}`);

        if (typeof value === 'boolean') {
            value = isEnabled.call(this, value);
        }

        if (typeof copiedNewData[label] === 'boolean') {
            copiedNewData[label] = isEnabled.call(this, copiedNewData[label]);
        }

        if (roles.includes(value)) {
            value = roleName.call(this, value);
        }

        if (roles.includes(copiedNewData[label])) {
            copiedNewData[label] = roleName.call(this, copiedNewData[label]);
        }

        if (Array.isArray(value)) {
            if (value.length && copiedNewData[label].length) {
                return translate([
                    fieldTranslation,
                    formatArray(value, label),
                    formatArray(copiedNewData[label], label)
                ], 'change');
            }

            if (value.length && !copiedNewData[label].length) {
                return translate([fieldTranslation, formatArray(value, label)], 'deleteField');
            }

            if (copiedNewData[label].length  && !value.length) {
                return translate([fieldTranslation, formatArray(copiedNewData[label], label)], 'add');
            }
        }

        if (!value) {
            return translate([fieldTranslation, Object.values(copiedNewData)[index]], 'add');
        }

        if (!copiedNewData[label]) {
            return translate([fieldTranslation, Object.values(copiedNewData)[index]], 'deleteField');
        }

        return translate([fieldTranslation, value, Object.values(copiedNewData)[index]], 'change');
    }).join('\n');

    ['passwordChanged', 'sqlQuery', 'meta'].forEach(key => {
        if (actionItem.action[key]) {
            changes += `\n${translate([], key)}`;
        }
    });

    return this.$vuetify.lang.t(`${translationPath}.edit`, translatedModel,  title || '', changes);
}

function changeDriverStatus(actionItem) {
    const { actionType: { name: type }, action: { callSign, status } }  = actionItem;
    const statusTranslation = this.$vuetify.lang.t(`$vuetify.pages.Logging.messages.driverStatus.${status}`);

    return this.$vuetify.lang.t(`$vuetify.pages.Logging.messages.${type}`, callSign, statusTranslation);
}

function isEnabled(value) {
    return this.$vuetify.lang.t(`$vuetify.pages.Logging.messages.${value ? 'enabled' : 'disabled'}`);
}

function roleName(value) {
    return this.$vuetify.lang.t(`$vuetify.roles.${value}`);
}

function remove(model, actionItem) {
    const { user: { firstName, lastName }, action } = actionItem;
    const deletedItem = Object.values(action)[0];
    const translatedModel = this.$vuetify.lang.t(`$vuetify.pages.Logging.models.${model}`);

    return this.$vuetify.lang.t(`${translationPath}.delete`, translatedModel, deletedItem, firstName, lastName);
}

function userLogin(actionItem) {
    const { firstName, lastName } = actionItem.user;
    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, firstName, lastName);
}

function formatArray(array, key) {
    return `[${array.map(it => it[assocc[key]] || it).join(', ')}]`;
}

function getSettingsEditTitle(title, key) {
    const directorOption = `${this.$vuetify.lang.t(`$vuetify.models.Settings.forDirector`)} [${title}] - ${key}`;
    const adminOption = `${this.$vuetify.lang.t(`$vuetify.models.Settings.forAdmin`)} - ${key}`;

    return title ? directorOption : adminOption;
}

function sendDriverPassword(actionItem) {
    const { title } = actionItem.action;
    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, title);
}

function backToWork(actionItem) {
    const { firstName, lastName } = actionItem.action;
    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, `${firstName} ${lastName}`);
}

function financeRemove(model, actionItem) {
    const { brand, optionName, title } = actionItem.action;
    const translatedModel = this.$vuetify.lang.t(`$vuetify.pages.Logging.models.${model}`);

    return this.$vuetify.lang.t(`${translationPath}.financeRemove`, translatedModel, optionName || title, brand);
}

function addDriverPayment(actionItem) {
    const { callSign, reason, sum, comment } = actionItem.action;

    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, callSign,
        this.$vuetify.lang.t(`$vuetify.models.Payment.${reason}`), sum, comment
    );
}

function resetImei(actionItem) {
    const { callSign } = actionItem.action;
    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, callSign);
}

function karmaChange(actionItem) {
    const { callSign, oldValue, newValue } = actionItem.action;

    return this.$vuetify.lang.t(
        `${translationPath}.${actionItem.actionType.name}`,
        callSign, oldValue, newValue
    );
}

function optionLevelEdit(actionItem) {
    const { oldValue, newValue } = actionItem.action;

    return this.$vuetify.lang.t(`${translationPath}.${actionItem.actionType.name}`, oldValue, newValue);
}

export function declination(n, variants) {
    const cases = [2, 0, 1, 1, 1, 2];
    const variant = variants[(n % 100 > 4 && n % 100 < 20) ? 2 : cases[Math.min(n % 10, 5)]];

    return variant ? variant.replace('%s', n) : '';
}
